module.exports = __webpack_public_path__ + "img/avatar.979823b9.png";